export function initInteractiveMaps(root = document) {
    root.querySelectorAll('.interactive-map:not([data-im-bound])').forEach(function (block) {
        block.dataset.imBound = 'true';

        var tabs = Array.from(block.querySelectorAll('.im-tab'));
        var panels = Array.from(block.querySelectorAll('.im-panel'));
        var listPanel = block.querySelector('.im-panel[data-panel="list"]');

        if (!tabs.length || !panels.length) {
            return;
        }

        function activateTab(nextTab) {
            var targetId = nextTab.getAttribute('aria-controls');

            tabs.forEach(function (tab) {
                var isActive = tab === nextTab;
                tab.classList.toggle('is-active', isActive);
                tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                tab.setAttribute('tabindex', isActive ? '0' : '-1');
            });

            panels.forEach(function (panel) {
                var isActive = panel.id === targetId;
                panel.classList.toggle('is-active', isActive);
                panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
                panel.hidden = !isActive;
            });
        }

        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                activateTab(tab);
            });

            tab.addEventListener('keydown', function (event) {
                var currentIndex = tabs.indexOf(tab);
                var nextIndex = -1;

                if (event.key === 'ArrowRight') {
                    nextIndex = (currentIndex + 1) % tabs.length;
                } else if (event.key === 'ArrowLeft') {
                    nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                } else if (event.key === 'Home') {
                    nextIndex = 0;
                } else if (event.key === 'End') {
                    nextIndex = tabs.length - 1;
                } else {
                    return;
                }

                event.preventDefault();
                tabs[nextIndex].focus();
                activateTab(tabs[nextIndex]);
            });
        });

        var activeTab = block.querySelector('.im-tab[aria-selected="true"]') || tabs[0];
        activateTab(activeTab);

        if (!listPanel) {
            return;
        }

        var endpoint = listPanel.getAttribute('data-api-endpoint');
        if (!endpoint) {
            return;
        }

        var loading = listPanel.querySelector('.im-list-loading');
        var cols = listPanel.querySelectorAll('.im-list-col');
        var accordionBaseId = listPanel.getAttribute('data-accordion-base') || listPanel.id;

        function createTextElement(tagName, className, text) {
            var element = document.createElement(tagName);
            element.className = className;
            element.textContent = text;
            return element;
        }

        function buildCity(city) {
            var cityEl = document.createElement('div');
            cityEl.className = 'im-city';

            if (city.name) {
                cityEl.appendChild(createTextElement('span', 'im-city-name', city.name));
            }

            if (city.address) {
                cityEl.appendChild(createTextElement('span', 'im-city-address', city.address));
            }

            if (city.phone) {
                var phoneWrap = document.createElement('span');
                phoneWrap.className = 'im-city-phone';

                var phoneLink = document.createElement('a');
                phoneLink.href = 'tel:' + String(city.phone).replace(/[^0-9+]/g, '');
                phoneLink.textContent = city.phone;
                phoneWrap.appendChild(phoneLink);
                cityEl.appendChild(phoneWrap);
            }

            return cityEl;
        }

        function buildCol(stateList, startIndex) {
            var frag = document.createDocumentFragment();

            stateList.forEach(function (state, stateIndex) {
                var itemIndex = startIndex + stateIndex;
                var stateId = accordionBaseId + '-state-' + itemIndex;
                var triggerId = stateId + '-trigger';
                var contentId = stateId + '-panel';
                var item = document.createElement('div');
                var trigger = document.createElement('button');
                var title = document.createElement('span');
                var icon = document.createElement('i');
                var content = document.createElement('div');

                item.className = 'im-accordion-item';

                trigger.type = 'button';
                trigger.className = 'im-accordion-trigger';
                trigger.id = triggerId;
                trigger.setAttribute('aria-expanded', 'false');
                trigger.setAttribute('aria-controls', contentId);

                title.textContent = state.name || '';
                icon.className = 'fas fa-chevron-down im-chevron';
                icon.setAttribute('aria-hidden', 'true');

                trigger.appendChild(title);
                trigger.appendChild(icon);

                content.className = 'im-accordion-content';
                content.id = contentId;
                content.setAttribute('aria-labelledby', triggerId);
                content.hidden = true;

                (state.cities || []).forEach(function (city) {
                    content.appendChild(buildCity(city));
                });

                trigger.addEventListener('click', function () {
                    var isOpen = item.classList.contains('is-open');

                    item.classList.toggle('is-open', !isOpen);
                    trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
                    content.hidden = isOpen;
                });

                item.appendChild(trigger);
                item.appendChild(content);
                frag.appendChild(item);
            });

            return frag;
        }

        fetch(endpoint)
            .then(function (res) {
                if (!res.ok) {
                    throw new Error('API error ' + res.status);
                }

                return res.json();
            })
            .then(function (data) {
                var states = data && Array.isArray(data.states) ? data.states : [];

                if (!states.length) {
                    if (loading) {
                        loading.textContent = 'No locations found.';
                    }

                    return;
                }

                if (loading) {
                    loading.remove();
                }

                cols.forEach(function (col) {
                    col.textContent = '';
                });

                var mid = Math.ceil(states.length / 2);
                var left = states.slice(0, mid);
                var right = states.slice(mid);

                if (cols[0]) {
                    cols[0].appendChild(buildCol(left, 0));
                }

                if (cols[1]) {
                    cols[1].appendChild(buildCol(right, left.length));
                }
            })
            .catch(function (err) {
                if (loading) {
                    loading.textContent = 'Could not load locations.';
                }

                console.error('interactive-map:', err);
            });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        initInteractiveMaps();
    });
} else {
    initInteractiveMaps();
}
